<template>
  <div id="pageRoot" class="blind">
    <p class="pageElement title" style="left: 30px; position: absolute; top: -20px">
      EL GRILLITO BUSCA...BUSCA
    </p>
    <span class="pageInstruction" style="left: 30px; top: 120px">
      <p>Escribe los nombres de los instrumentos musicales<br>que no perdió el grillito.</p>
    </span>

    <img
    style="width: 200px; top: 250px; left: 100px"
    class="pageElement basicItem01"
    src="/pages/img/blindvio/assets_p5/piano.svg"
    />
    <img
    style="width: 150px; top: 230px; left: 420px"
    class="pageElement basicItem01"
    src="/pages/img/blindvio/assets_p5/tambor.svg"
    />
    <img
    style="width: 200px; top: 230px; right: 100px"
    class="pageElement basicItem01"
    src="/pages/img/blindvio/assets_p5/violin.svg"
    />
    <img
    style="width: 200px; top: 440px; left: 100px"
    class="pageElement basicItem01"
    src="/pages/img/blindvio/assets_p5/guitarra.svg"
    />
    <img
    style="width: 150px; top: 500px; left: 420px"
    class="pageElement basicItem01"
    src="/pages/img/blindvio/assets_p5/pandereta.svg"
    />
    <img
    style="width: 180px; top: 430px; right: 100px"
    class="pageElement basicItem01"
    src="/pages/img/blindvio/assets_p5/maraca.svg"
    />

    <saved-input-long-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
      maxCharacters="80"
      style="line-height: 45px;
      width: 750px;
      height: 100px;
      left: 90px;
      bottom: 40px;
      padding-left: 10px;
      font-size: 30px;"
    />

  </div>
</template>
<style scoped>
#bg{
    position: absolute;
    left: 31px;
    top: 33px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "vio/Video 9.mp4",
        "vio/Video 10.mp4",
        "vio/Video 11.mp4",
        "vio/Video 12.mp4",
        "vio/Video 13.mp4",
      ],
    };
  },
  methods: {
    dbId(name, option) {
      return `${this.$parent.pageID()}-${name}-${option}`;
    },
    async loadOption(name, option) {
      var id = this.dbId(name, option);

      var value = await this.$db.options
        .get({
          id: id,
        })
        .catch(function (error) {
          console.log("error getting option" + error);
        });
      if (value === undefined) return;
      console.log(value);

      this.$refs[option].checked = value.option;

      console.log("option loaded: " + id + ", " + value.option);
    },
    saveOption(name, option) {
      var id = this.dbId(name, option);
      var value = this.$refs[option].checked;

      this.$db.options
        .put({
          id: id,
          option: value,
        })
        .catch(function (error) {
          console.log("error saving option" + error);
        });

      console.log("option saved: " + id + ", " + value);
    },
  },
  mounted() {},
};
</script>